import { Stack } from '@carbon/react';
import { FormController } from '@form-ts/core';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { UserFormData } from 'src/modules/common/types/UserFormData';
import { TextField } from 'src/modules/form/components/TextField';
import { FormError } from 'src/modules/form/types/FormError';

type Props = {
  className?: string;
  disableEmail?: boolean;
  form: FormController<UserFormData, FormError>;
  isUserCreation: boolean;
};

export const UserForm = memo(({
  className, disableEmail, form, isUserCreation,
}: Props): React.ReactElement => {
  const intl = useIntl();

  return (
    <Stack className={className} gap="1rem" orientation="vertical">
      <TextField
        disabled={disableEmail}
        field={form.field.at('email')}
        label={isUserCreation
          ? intl.formatMessage({ id: 'admin/user/form/field/email' })
          : intl.formatMessage({ id: 'admin/user/form/field/username' })}
        required={true}
        size="md"
        maxLength={50}
        description={null}
      />

      <TextField
        field={form.field.at('firstName')}
        label={intl.formatMessage({ id: 'admin/user/form/field/firstName' })}
        maxLength={50}
        description={null}
        required={true}
        size="md"
      />

      <TextField
        field={form.field.at('lastName')}
        label={intl.formatMessage({ id: 'admin/user/form/field/lastName' })}
        maxLength={50}
        description={null}
        required={true}
        size="md"
      />

      <TextField
        field={form.field.at('jobTitle')}
        label={intl.formatMessage({ id: 'admin/user/form/field/jobTitle' })}
        description={null}
        size="md"
      />
    </Stack>
  );
});
